export class RedshiftRestoreDestination {
    'region';
    'clusterIdentifier';
    'namespaceName';
    'nodeType';
    'numberOfNodes';
    'subnetGroupName';
    'vpcSecurityGroupIds';
    'port';
    'encryptionKey';
    'tags';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterIdentifier",
            "baseName": "clusterIdentifier",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespaceName",
            "baseName": "namespaceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "nodeType",
            "baseName": "nodeType",
            "type": "string",
            "format": ""
        },
        {
            "name": "numberOfNodes",
            "baseName": "numberOfNodes",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "subnetGroupName",
            "baseName": "subnetGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcSecurityGroupIds",
            "baseName": "vpcSecurityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "port",
            "baseName": "port",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RedshiftRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
